import { useQuery } from '@tanstack/react-query';
import { api } from 'src/services';
import { UseQueryOverrideOptions } from '../common';
import { AppointmentType } from 'src/models';

export type UseGetAppointmentTypesParams = {};

export type GetAppointmentTypesResponse = {
  appointment_types: AppointmentType[];
};

export const useGetAppointmentTypes = (
  params: UseGetAppointmentTypesParams = {},
  options: UseQueryOverrideOptions = {}
) => {
  return useQuery({
    ...options,
    queryKey: ['appointmentTypes', params],
    queryFn: () =>
      api
        .get<GetAppointmentTypesResponse>('/appointment_types')
        .then((res) => res.data),
  });
};
